__webpack_require__.p = "/einkaufsliste/";